import React, { useState } from 'react';
import '../styles/TPV.css';
import { IMAGE_PATHS } from '../config/paths';
import { useHistory } from 'react-router-dom';
import { lang, getLang } from '../lang';

interface CardData {
    id: number;
    text: string;
}

const cardContent: CardData[] = lang.TPVProyectos.cards.map((text, i) => ({ id: i + 1, text }));

const routes = {
    es: {
        projects: '/proyectos'
    },
    en: {
        projects: '/en/projects'
    }
};

const TPV: React.FC = () => {
    const [currentCardIndex, setCurrentCardIndex] = useState(0);
    const history = useHistory();
    const currentLang = getLang();

    const handleClickNext = () => {
        setCurrentCardIndex((prevIndex) => (prevIndex + 1) % cardContent.length);
    };

    const handleClickPrev = () => {
        setCurrentCardIndex((prevIndex) => (prevIndex - 1 + cardContent.length) % cardContent.length);
    };

    const handleSaberMas = () => {
        history.push(`${routes[currentLang].projects}#tpv`);
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 100);
    };

    return (
        <section className="tpv-section tpv-main">
            <div className="tpv-title-section">
                <img 
                    src={IMAGE_PATHS.TPV} 
                    alt="TPV - Juego de cartas de humor negro y diversión sin límites" 
                    className="tpv-title-image" 
                />
            </div>
            <div className="tpv-container">
                <div className="card-carousel-wrapper">
                    <div className="card-navigation-arrow left-arrow" onClick={handleClickPrev} aria-label="Ver carta anterior">&lt;</div>
                    <div className="card-container">
                        {cardContent.map((card, index) => {
                            let positionClass = '';
                            if (index === currentCardIndex) {
                                positionClass = 'current';
                            } else if (index === (currentCardIndex - 1 + cardContent.length) % cardContent.length) {
                                positionClass = 'previous';
                            } else if (index === (currentCardIndex + 1) % cardContent.length) {
                                positionClass = 'next';
                            } else {
                                positionClass = 'hidden';
                            }
                            return (
                                <div key={card.id} className={`card-content-box ${positionClass}`} role="article" aria-label={`Característica ${card.id} de TPV`}>
                                    <p>{card.text}</p>
                                </div>
                            );
                        })}
                    </div>
                    <div className="card-navigation-arrow right-arrow" onClick={handleClickNext} aria-label="Ver siguiente carta">&gt;</div>
                </div>
                <div className="monitor-display-wrapper">
                    <div className="monitor-screen">
                        <div className="sliding-images-container">
                            <img src={IMAGE_PATHS.ABUELA} alt="Personaje TPV: Abuela - Carta de humor negro" className="monitor-image" />
                            <img src={IMAGE_PATHS.GITANA} alt="Personaje TPV: Gitana - Carta de humor negro" className="monitor-image" />
                            <img src={IMAGE_PATHS.FRIKI} alt="Personaje TPV: Friki - Carta de humor negro" className="monitor-image" />
                            <img src={IMAGE_PATHS.GATO} alt="Personaje TPV: Gato - Carta de humor negro" className="monitor-image" />
                            <img src={IMAGE_PATHS.PEZ} alt="Personaje TPV: Pez - Carta de humor negro" className="monitor-image" />
                            <img src={IMAGE_PATHS.FACHA} alt="Personaje TPV: Facha - Carta de humor negro" className="monitor-image" />
                            <img src={IMAGE_PATHS.MACHO} alt="Personaje TPV: Macho - Carta de humor negro" className="monitor-image" />
                        </div>
                    </div>
                    <div className="monitor-base"></div>
                </div>
            </div>

            <div className="saber-mas-section">
                <button className="saber-mas-button" onClick={handleSaberMas}>
                    {lang.TPV.saberMas}
                </button>
            </div>
        </section>
    );
};

// Componente TPV específico para Proyectos
export const TPVProyectos: React.FC = () => {
    const [currentCardIndex, setCurrentCardIndex] = useState(0);

    const handleClickNext = () => {
        setCurrentCardIndex((prevIndex) => (prevIndex + 1) % cardContent.length);
    };

    const handleClickPrev = () => {
        setCurrentCardIndex((prevIndex) => (prevIndex - 1 + cardContent.length) % cardContent.length);
    };

    return (
        <section className="tpv-section proyectos-tpv">
            <div className="tpv-title-section">
                <img src={IMAGE_PATHS.TPV} alt="TPV" className="tpv-title-image" />
            </div>
            <div className="tpv-container">
                <div className="card-carousel-wrapper">
                    <div className="card-navigation-arrow left-arrow" onClick={handleClickPrev}>&lt;</div>
                    <div className="card-container">
                        {cardContent.map((card, index) => {
                            let positionClass = '';
                            if (index === currentCardIndex) {
                                positionClass = 'current';
                            } else if (index === (currentCardIndex - 1 + cardContent.length) % cardContent.length) {
                                positionClass = 'previous';
                            } else if (index === (currentCardIndex + 1) % cardContent.length) {
                                positionClass = 'next';
                            } else {
                                positionClass = 'hidden';
                            }
                            return (
                                <div key={card.id} className={`card-content-box ${positionClass}`}>
                                    <p>{card.text}</p>
                                </div>
                            );
                        })}
                    </div>
                    <div className="card-navigation-arrow right-arrow" onClick={handleClickNext}>&gt;</div>
                </div>
                <div className="monitor-display-wrapper">
                    <div className="monitor-screen">
                        <div className="sliding-images-container">
                            <img src={IMAGE_PATHS.ABUELA} alt="Abuela" className="monitor-image" />
                            <img src={IMAGE_PATHS.GITANA} alt="Gitana" className="monitor-image" />
                            <img src={IMAGE_PATHS.FRIKI} alt="Friki" className="monitor-image" />
                            <img src={IMAGE_PATHS.GATO} alt="Gato" className="monitor-image" />
                            <img src={IMAGE_PATHS.PEZ} alt="Pez" className="monitor-image" />
                            <img src={IMAGE_PATHS.FACHA} alt="Facha" className="monitor-image" />
                            <img src={IMAGE_PATHS.MACHO} alt="Macho" className="monitor-image" />
                        </div>
                    </div>
                    <div className="monitor-base"></div>
                </div>
            </div>
        </section>
    );
};

export default TPV; 